export enum PhoneType {
  CELLULAR = 1,
  LINE = 2,
  WHATSAPP = 11,
  ANY = 99,
  OTHERS = 9,
}
